// extracted by mini-css-extract-plugin
export default {"trip":"trip_trip__Wwodo","marker":"trip_marker__t+6Vn"};